import { defineComponent as _defineComponent } from 'vue'

    const __default__ = {
        model: {
            prop: 'modelValue',
            event: 'update:modelValue',
        },
    };

import { useViewport } from '@travelata-libs/utils';
    import { computed, watch } from 'vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';
    import { BONUS_MILES_TEXT, hasNonBonusMilesOperators } from '../../lib/filterByBonusMiles';
    import BonusMilesBadge from './BonusMilesBadge.vue';

    enum BonusMilesFilterVariant {
        Filter = 'filter',
        FilterSecondary = 'filter-secondary',
        Checkbox = 'checkbox',
    }

    interface BonusMilesFilterProps {
        modelValue: boolean;
        isHovered?: boolean;
        variant?: `${BonusMilesFilterVariant}`;
        selectedOperators?: number[];
    }

    interface BonusMilesFilterEmits {
        (e: 'update:modelValue', value: boolean): void;
    }

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BonusMilesFilter',
  props: {
    modelValue: { type: Boolean },
    isHovered: { type: Boolean, default: false },
    variant: { default: 'filter' },
    selectedOperators: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'update:modelValue', value: boolean): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, isHovered: boolean, variant: `${BonusMilesFilterVariant}`, selectedOperators: number[] }

    

    

    const { isMobile } = useViewport();

    const isSelected = computed({
        get: () => props.modelValue,
        set: (v: boolean) => emit('update:modelValue', v),
    });

    const badgeOptionsMap = {
        [BonusMilesFilterVariant.Filter]: {
            iconVariant: 'green',
        },
        [BonusMilesFilterVariant.FilterSecondary]: {
            iconVariant: 'light-green',
        },
        [BonusMilesFilterVariant.Checkbox]: {
            iconVariant: 'none',
            tooltipIcon: 'airplane',
        },
    };

    const badgeOptions = computed(() => badgeOptionsMap[props.variant]);

    const isDisabled = computed(() => hasNonBonusMilesOperators(props.selectedOperators));

    watch(
        isDisabled,
        (value) => {
            if (value) emit('update:modelValue', false);
        },
        { immediate: true },
    );

return { __sfc: true,BonusMilesFilterVariant, props, emit, isMobile, isSelected, badgeOptionsMap, badgeOptions, isDisabled, CheckBoxInput, TextCommon, BONUS_MILES_TEXT, BonusMilesBadge }
}

})